<script>
import router from "../../router";
import Alert from "@/components/Alert";
export default {
  name: "AddKitchenPrinter",
  components: {
    Alert
  },
  data() {
    return {
      categories: [],
      selectedCategories: [],
      printer: {
        name: ""
      }
    };
  },
  methods: {
    getCategories() {
      this.categories = [];
      this.$api
        .getAPI({
          _action: "/backoffice-setting/get-categories"
        })
        .then(res => {
          this.categories = res.list;
         
          if(this.printer.id){
             this.details();
          }
        });
    },


    details() {
    
      this.$api
        .getAPI({
          _action: "/backoffice-setting/get-kitchen-printers/" + this.printer.id
        })
        .then(res => {
          this.printer = {};
          this.printer = res;

          if (res.categories && res.categories.length > 0) {
            this.selectedCategories = res.categories;
          } else {
            this.selectedCategories = [];
          }

          
        });
    },
    save() {
      if (this.selectedCategories.length > 0) {
        this.printer.list = this.selectedCategories;
      } else {
        this.printer.list = [];
      }

      this.$api
        .postAPI({
          _action: "/backoffice-setting/save-kitchen-printers",
          _body: this.printer,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });

          router.push("/settings");
        })
        .catch(e => {});
    },
    deleteDinningOption() {
      if (this.printer.id) {
        this.$api
          .deleteAPI({
            _action:
              "/backoffice-setting/dinning-option/delete/" + this.printer.id
          })
          .then(res => {
            this.$refs.deletePrinterAlert.close();
            this.$notify({
              group: "foo",
              text: res.message,
              type: "success"
            });
            router.push("/settings");
          })
          .catch(e => {
            this.$refs.deletePrinterAlert.close();
          });
      }
    },
    setObj() {
      this.$refs.deletePrinterAlert.message = this.$lang.messages.delete_kitchen_printer_message;
    },
    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.save();
          return;
        }
      });
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.printer.id = this.$route.params.id;
    }

    
     this.getCategories();
   

    
  }
};
</script>
<template>
  <div class="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6">
          <div class="card rounded-5 p-3 border">
            <div class="card-body form-style">
              <div class="row">
                <div class="col-lg-12 mb-4">
                  <label for>{{$lang.messages.name}}</label><span style="color:#ff0000"> *</span>
                  <input
                    name="name"
                    v-model="printer.name"
                    v-validate="'required|max:300'" maxlength="300"
                    class="form-control" 
                    :class="{'input': true, 'is-danger': errors.has('name') }"
                    type="text"
                    v-bind:placeholder="$lang.messages.name"
                  />
                  <i v-show="errors.has('name')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('name')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_valid_name}}</span>
                </div>

                <div class="col-lg-12 mb-4">
                  <h3 class="mb-1">{{$lang.messages.categories}}</h3>
                  <p
                    class="font-14 text-grey"
                  >{{$lang.messages.categories_printed_on_this_group}} </p>
                </div>
                <div class="col-lg-12 mb-4">
                  <div class="custom-control custom-checkbox mb-3"  v-for="category in categories"
                    :key="category.id">
                    <input type="checkbox"  class="custom-control-input" :value="category.id"
                      :id="'category_'  +category.id"
                      v-model="selectedCategories"
                        :disabled=" ( category.is_checked != null && category.is_checked && (!category.kitchen_printer_id || printer.id != category.kitchen_printer_id)) "/>
                   <label
                      class="custom-control-label text-dark ml-2"
                      :for="'category_' +category.id"
                    >{{category.name}}</label>
                  </div>
                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 text-lg-right text-center">
          <button type="button"    @click="validateForm()"
              id="save-btn" class="btn btn-primary mr-3">{{$lang.messages.save_btn_text}}</button>
          <button type="button" class="btn btn-outline-primary" @click="$router.go(-1)">{{$lang.messages.cancel_btn_text}}</button>
        </div>
      </div>
    </div>
  </div>
</template>